import React, { useEffect, useRef, useState } from "react";
import {
  MultiSelectCheckmark,
  MultiSelectChevron,
  MultiSelectChip,
  MultiSelectChipRemove,
  MultiSelectControl,
  MultiSelectDropdown,
  MultiSelectOption,
  MultiSelectPlaceholder,
  MultiSelectWrapper,
} from "../styles";

const ChevronIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="2 5 7 10 12 5" />
  </svg>
);

export const MultiSelect = ({ options = [], value = [], onChange, placeholder }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selected = Array.isArray(value) ? value : [];

  const toggle = (optionValue) => {
    if (selected.includes(optionValue)) {
      onChange(selected.filter((v) => v !== optionValue));
    } else {
      onChange([...selected, optionValue]);
    }
  };

  const remove = (e, optionValue) => {
    e.stopPropagation();
    onChange(selected.filter((v) => v !== optionValue));
  };

  const getLabelByValue = (val) => {
    const opt = options.find((o) => o.value === val);
    return opt ? opt.label : val;
  };

  return (
    <MultiSelectWrapper ref={wrapperRef}>
      <MultiSelectControl $open={open} onClick={() => setOpen((o) => !o)}>
        {selected.length === 0 ? (
          <MultiSelectPlaceholder>{placeholder}</MultiSelectPlaceholder>
        ) : (
          selected.map((val) => (
            <MultiSelectChip key={val} title={getLabelByValue(val)}>
              {getLabelByValue(val)}
              <MultiSelectChipRemove
                type="button"
                onClick={(e) => remove(e, val)}
                tabIndex={-1}
              >
                ×
              </MultiSelectChipRemove>
            </MultiSelectChip>
          ))
        )}
        <MultiSelectChevron $open={open}>
          <ChevronIcon />
        </MultiSelectChevron>
      </MultiSelectControl>

      {open && (
        <MultiSelectDropdown>
          {options.map((opt) => {
            const isSelected = selected.includes(opt.value);
            return (
              <MultiSelectOption
                key={opt.value}
                $selected={isSelected}
                onClick={() => toggle(opt.value)}
              >
                <MultiSelectCheckmark $checked={isSelected} />
                {opt.label}
              </MultiSelectOption>
            );
          })}
        </MultiSelectDropdown>
      )}
    </MultiSelectWrapper>
  );
};
